import { coreClient as client } from '@app/helpers/requests/client';
import { responseDataAdapter } from '@app/helpers/requests/bennieFetch';

export const fetchProfile = () =>
  client.get(`/v1/profile`).then(data => responseDataAdapter(data));

export const fetchProfileApplicationStatus = () =>
  client
    .get(`/v1/profile/applicationstatus`)
    .then(data => responseDataAdapter(data));
